// ============================================================================
// Hook per gestione automezzi — Supabase
// ============================================================================

import { useState, useEffect, useCallback } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabase";

export function useAutomezzi() {
  const [automezzi, setAutomezzi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isSupabaseConfigured) { setLoading(false); return; }

    supabase
      .from("automezzi")
      .select("*")
      .order("id", { ascending: true })
      .then(({ data, error }) => {
        if (error) { console.error("Errore caricamento automezzi:", error); setLoading(false); return; }
        if (data) setAutomezzi(data);
        setLoading(false);
      });

    const channel = supabase
      .channel("automezzi_realtime")
      .on("postgres_changes", { event: "INSERT", schema: "public", table: "automezzi" }, (payload) => {
        setAutomezzi((prev) => prev.some((a) => a.id === payload.new.id) ? prev : [...prev, payload.new]);
      })
      .on("postgres_changes", { event: "UPDATE", schema: "public", table: "automezzi" }, (payload) => {
        setAutomezzi((prev) => prev.map((a) => a.id === payload.new.id ? payload.new : a));
      })
      .on("postgres_changes", { event: "DELETE", schema: "public", table: "automezzi" }, (payload) => {
        setAutomezzi((prev) => prev.filter((a) => a.id !== payload.old.id));
      })
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  const saveAutomezzo = useCallback(async (id, data) => {
    setAutomezzi((prev) => prev.map((a) => a.id === id ? { ...a, ...data } : a));
    if (!isSupabaseConfigured) return { success: true };
    const { error } = await supabase
      .from("automezzi")
      .update(data)
      .eq("id", id);
    if (error) return { success: false, error: error.message };
    return { success: true };
  }, []);

  const addAutomezzo = useCallback(async (data) => {
    if (!isSupabaseConfigured) {
      const fake = { id: Date.now(), ...data };
      setAutomezzi((prev) => [...prev, fake]);
      return { success: true };
    }
    const { data: inserted, error } = await supabase
      .from("automezzi")
      .insert([data])
      .select();
    if (error) { console.error("Errore aggiunta automezzo:", error); return { success: false, error: error.message }; }
    // Aggiunge solo se il realtime non l'ha già fatto
    setAutomezzi((prev) => prev.some((a) => a.id === inserted[0].id) ? prev : [...prev, inserted[0]]);
    return { success: true };
  }, []);

  const deleteAutomezzo = useCallback(async (id) => {
    setAutomezzi((prev) => prev.filter((a) => a.id !== id));
    if (!isSupabaseConfigured) return;
    await supabase.from("automezzi").delete().eq("id", id);
  }, []);

  return { automezzi, loading, saveAutomezzo, addAutomezzo, deleteAutomezzo };
}
